/**
 * Cookies 的 key 值
 */
export enum CookiesKey {
  /**
   * 關閉瀏覽器再次開啟時，如為登入狀態需登出。
   * 若 DO_NOT_LOGOUT 存在代表尚未關閉過瀏覽器，不需登出
   */
  DO_NOT_LOGOUT = 'doNotLogout',
  /**
   * 長榮官網設定的 Cookies
   */
  S_MEMBER = 'sMember',
  /**
   * otp 認證的 Cookies
   */
  OTP_DATA = 'otpData',
  /**
   * otp 認證的 裝置 token
   */
  DEVICE_TOKEN = 'deviceToken'
}
